import { CSSProperties } from "react";
import { variants } from "./enums";
import { TypographyProps } from "./types";

export default function Typography({
  variant = "body",
  children,
  style,
  noWrap = false,
  ...props
}: TypographyProps) {
  const noWrapStyles: CSSProperties = noWrap
    ? {
        whiteSpace: "nowrap" as const,
        overflow: "hidden" as const,
        textOverflow: "ellipsis" as const,
      }
    : {};

  return (
    <span style={{ ...variants[variant], ...noWrapStyles, ...(style || {}) }} {...props}>
      {children}
    </span>
  );
}
